<template>
  <v-row class="h-screen">
    <v-col cols="" align-self="center">
      <v-card class="pa-3 mx-auto" max-width="500">
        <v-overlay :model-value="loading" contained class="align-center justify-center">
          <v-progress-circular indeterminate size="64" color="primary" />
        </v-overlay>
        <v-img
          v-if="branding.logoUrl"
          class="mx-auto"
          :src="branding.logoUrl"
          :alt="branding.portalName"
          max-width="190"
          max-height="75"
        />
        <v-card-title
          v-if="(!branding.logoUrl && branding.portalName) || isGeneratedShopDomain"
          class="d-flex flex-column align-center"
        >
          <sf-title
            v-if="!branding.logoUrl && branding.portalName"
            ref="no-logo-fallback"
            class="font-weight-bold"
          >
            {{ branding.portalName }}
          </sf-title>
          <b2-b-commerce-hint v-if="isGeneratedShopDomain" small />
        </v-card-title>
        <v-card-title ref="title" class="d-flex align-center">
          <v-divider class="my-1" />
          <div class="mx-2">{{ title }}</div>
          <v-divider class="my-1" />
        </v-card-title>
        <v-card-text>
          <!-- content -->
          <slot />
          <login-footer
            :owner-name="branding.ownerName"
            :terms-url="branding.termsUrl || undefined"
            :privacy-url="branding.privacyUrl || undefined"
            :legal-info-url="branding.legalInfoUrl || undefined"
          />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import SfTitle from '@/components/text/SfTitle.vue'
import { isGeneratedShopDomain } from '@/helpers'
import B2BCommerceHint from '@/modules/authentication/components/B2BCommerceHint.vue'
import LoginFooter from '@/modules/authentication/components/LoginFooter.vue'
import { Branding } from '@/modules/portalSettings/types'
import { PropType } from 'vue'

defineProps({
  branding: {
    type: Object as PropType<Branding>,
    required: true
  },
  title: {
    type: String,
    required: true
  },
  loading: {
    type: Boolean,
    default: false
  }
})
</script>
